import type {
  KinerjaHarianLogState,
  KinerjaHarianBadgeConfig,
  KinerjaHarianBadgeTone,
} from 'types/kinerja-harian'

export const PAGE_SIZE = 10

export const EDIT_DELETE_DISABLED_STATES: KinerjaHarianLogState[] = [
  'SENT_TO_BKN',
  'SENT_TO_BKN_SUCCESS',
  'SENT_TO_BKN_FAILED',
]

export const ALL_MONTH_OPTION = 'all'
export const WIB_SUFFIX = 'WIB'

export const MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
] as const

export const WEEKDAY_LABELS = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']

export type CalendarStatus =
  | 'EMPTY'
  | 'SUBMITTED'
  | 'SUCCESS'
  | 'FAILED'
  | 'SENDING'

// Note: tailwind colors not matching Figma, so using the hex code directly
export const CALENDAR_STATUS_CONFIG: Record<
  CalendarStatus,
  {
    cellClassName: string
    dotClassName?: string
    label: string
  }
> = {
  EMPTY: {
    cellClassName: 'bg-[#F1F1F1]',
    label: 'Belum ada catatan',
  },
  SUBMITTED: {
    cellClassName: 'bg-[#FDF2B2]',
    dotClassName: 'bg-[#BF6F02]',
    label: 'Belum Dikirim ke E-Kinerja',
  },
  SENDING: {
    cellClassName: 'bg-[#E6F1FF]',
    dotClassName: 'bg-blue-60',
    label: 'Sedang Dikirim ke E-Kinerja',
  },
  SUCCESS: {
    cellClassName: 'bg-[#BBE2B8]',
    dotClassName: 'bg-[#369536]',
    label: 'Sudah Dikirim ke E-Kinerja',
  },
  FAILED: {
    cellClassName: 'bg-[#FEEDF2]',
    dotClassName: 'bg-red-50',
    label: 'Gagal Dikirim ke E-Kinerja',
  },
}

export const CALENDAR_STATUS_BY_STATE: Record<
  KinerjaHarianLogState,
  CalendarStatus
> = {
  SENT_TO_BKN_SUCCESS: 'SUCCESS',
  SENT_TO_BKN_FAILED: 'FAILED',
  SENT_TO_BKN: 'SENDING',
  SUBMITTED: 'SUBMITTED',
}

export const BADGE_CONFIG_BY_STATE: Record<
  KinerjaHarianLogState,
  KinerjaHarianBadgeConfig
> = {
  SENT_TO_BKN_SUCCESS: {
    label: 'Sudah Dikirim ke E-Kinerja',
    tone: 'success' as KinerjaHarianBadgeTone,
  },
  SENT_TO_BKN_FAILED: {
    label: 'Gagal Dikirim ke E-Kinerja',
    tone: 'failed' as KinerjaHarianBadgeTone,
  },
  SUBMITTED: {
    label: 'Belum Dikirim ke E-Kinerja',
    tone: 'warning' as KinerjaHarianBadgeTone,
  },
  SENT_TO_BKN: {
    label: 'Sedang Dikirim ke E-Kinerja',
    tone: 'informational' as KinerjaHarianBadgeTone,
  },
} as const

export const ABSENT_BADGE_CONFIG: KinerjaHarianBadgeConfig = {
  label: 'Tidak Hadir',
  tone: 'failed' as KinerjaHarianBadgeTone,
} as const

export const ABSENT_NOTE_MESSAGE =
  'Jenis Kinerja tidak perlu diisi karena Anda memilih Tidak Hadir pada tanggal yang dipilih.'

export const CONTENT_FORM_DESCRIPTIONS: Record<
  'GURU' | 'KS' | 'GPK' | 'PS',
  string
> = {
  GURU: `Sesuai dengan Tugas Pokok 5M Guru dan Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Kepala Sekolah.`,
  KS: `Sesuai dengan beban kerja dan tugas Kepala Sekolah, serta Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Tim Kinerja atau Pejabat Penilai Kinerja.`,
  GPK: `Sesuai dengan Tugas Guru Pendidikan Khusus (GPK) dan Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Tim Kinerja dan Pejabat Penilai Kinerja.`,
  PS: `Sesuai dengan beban kerja dan tugas Pengawas Sekolah serta Pengembangan Kompetensi yang sejalan dengan Perencanaan Anda. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Tim Kinerja atau Pejabat Penilai Kinerja.`,
}
